import { LogOut } from 'lucide-react'

interface LogoutIndicatorProps {
  isLoggingOut: boolean
}

export default function LogoutIndicator({ isLoggingOut }: LogoutIndicatorProps) {
  if (!isLoggingOut) return null

  return (
    <div className="fixed top-4 left-4 z-50 flex items-center space-x-2 bg-violet-500/90 backdrop-blur-md text-white px-4 py-2 rounded-lg shadow-lg border border-violet-400/30">
      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
      <LogOut className="w-4 h-4" />
      <span className="text-sm font-medium">正在登出...</span>
    </div>
  )
} 